import { useState } from 'react';
import classNames from 'classnames';

import Button from 'components/atoms/Button';

import { ToggleSelectOption } from 'utils/frontendTypes';

interface ToggleButtonProps<T> {
  className?: string;
  callback: (value: T) => void;
  disabled?: boolean;
  initialState?: string;
  left: ToggleSelectOption<T>;
  right: ToggleSelectOption<T>;
}

function ToggleButton<T>({ callback, className, disabled, initialState, left, right }: ToggleButtonProps<T>) {
  const [isSelected, setIsSelected] = useState(initialState || left.value);

  const handleToggle = () => {
    const newIsSelected = isSelected === left.value ? right.value : left.value;

    setIsSelected(newIsSelected);
    callback(newIsSelected);
  };

  const buttonType = (selected, value) => {
    if (selected === value) {
      return 'secondary';
    }
    return 'tertiary';
  };

  return (
    <div>
      <div className={classNames('flex rounded-full', disabled && 'opacity-50 pointer-events-none', className)}>
        <Button
          type={buttonType(isSelected, left.value)}
          icon={left.icon}
          iconSize={12}
          dataDurableId="leftToggleButton"
          onClick={handleToggle}
          text={left.label}
          hideHighlight
          className={classNames('flex-1 z-1 justify-center h-10 text-sm whitespace-nowrap', {
            '-mr-2 z-10': isSelected === left.value,
          })}
        />
        <Button
          type={buttonType(isSelected, right.value)}
          icon={right.icon}
          iconSize={12}
          dataDurableId="rightToggleButton"
          onClick={handleToggle}
          text={right.label}
          hideHighlight
          className={classNames('flex-1 z-0 justify-center h-10 text-sm', { '-ml-2 z-10': isSelected !== left.value })}
        />
      </div>
    </div>
  );
}
export default ToggleButton;
